module.exports = __webpack_public_path__ + "static/img/done.e0dbb8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/done.png
// module id = VtX1
// module chunks = 1